import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import InstallPrompt from "./components/InstallPrompt";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import SectorSelect from "./pages/SectorSelect";
import QuoteWizard from "./pages/QuoteWizard";
import QuotesList from "./pages/QuotesList";
import QuoteDetail from "./pages/QuoteDetail";
import OffersCatalog from "./pages/OffersCatalog";
import AdminDashboard from "./pages/AdminDashboard";
import EnergyQuoter from "./pages/EnergyQuoter";
import PublicQuotePage from "./pages/PublicQuotePage";
import BrandedOfferGenerator from "./pages/BrandedOfferGenerator";
import Communications from "./pages/Communications";
import CommunicationDetail from "./pages/CommunicationDetail";
import FileRedirect from "./pages/FileRedirect";
import MyContracts from "./pages/MyContracts";
import ContractDetail from "./pages/ContractDetail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const protectedWithLayout = (node) => (
    <ProtectedRoute>
        <Layout>{node}</Layout>
    </ProtectedRoute>
);

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <InstallPrompt />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/p/:token" element={<PublicQuotePage />} />
                    <Route path="/file/:id" element={<FileRedirect />} />

                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={protectedWithLayout(<Dashboard />)} />
                    <Route
                        path="/nuovo-preventivo"
                        element={protectedWithLayout(<SectorSelect />)}
                    />
                    <Route
                        path="/nuovo-preventivo/:sector"
                        element={protectedWithLayout(<QuoteWizard />)}
                    />
                    <Route path="/richieste" element={protectedWithLayout(<QuotesList />)} />
                    <Route path="/richieste/:id" element={protectedWithLayout(<QuoteDetail />)} />
                    <Route path="/offerte" element={protectedWithLayout(<OffersCatalog />)} />
                    <Route path="/energy-quoter" element={protectedWithLayout(<EnergyQuoter />)} />
                    <Route path="/comunicazioni" element={protectedWithLayout(<Communications />)} />
                    <Route path="/comunicazioni/:id" element={protectedWithLayout(<CommunicationDetail />)} />
                    <Route path="/contratti" element={protectedWithLayout(<MyContracts />)} />
                    <Route path="/contratti/:id" element={protectedWithLayout(<ContractDetail />)} />

                    <Route
                        path="/admin/genera-offerta"
                        element={
                            <ProtectedRoute adminOnly>
                                <Layout>
                                    <BrandedOfferGenerator />
                                </Layout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute adminOnly>
                                <Layout>
                                    <AdminDashboard />
                                </Layout>
                            </ProtectedRoute>
                        }
                    />

                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
